module.exports = __webpack_public_path__ + "img/hr-branch-particle-09.b92d92f7.png";